import React, { useEffect } from 'react';
import Header from "../pages/include/Header";
import Sidebar from "../pages/include/Sidebar";
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

axios.interceptors.request.use(
    (req) => {
        req.headers.Authorization = 'Bearer ' + sessionStorage.getItem('accessToken');
        return req;
    },
    (err) => {
        if (err.response.status === 401) {
        }
        return Promise.reject(err);
    }
);
axios.interceptors.response.use(
    (res) => {
        res.headers.Authorization = 'Bearer ' + sessionStorage.getItem('accessToken');
        return res;
    },
    (err) => {
        if (err.response.status === 401) {
        }
        return Promise.reject(err);
    }
);

const AdminLayout = ({ component: Component }) => {

    const isLogin = sessionStorage.getItem('accessToken');
    const navigate = useNavigate();
    const location = useLocation();

    // Check if current path is a legal page accessed through admin routes
    const isLegalPage = location.pathname.includes('/legal/terms-privacy') || 
                       location.pathname.includes('/legal/help');


    useEffect(() => {
        // Redirect to login if not authenticated and not on legal pages
        if (!isLogin && !isLegalPage) {
            navigate('/login', { replace: true });
            return;
        }

        const checkSubscriptionAndRedirect = () => {
            const user = JSON.parse(sessionStorage.getItem("user"));
            if (user && user.seller_profile) {
                const subscriptionStatus = user.seller_profile.subscription_status;
                if (!subscriptionStatus && !location.pathname.includes('/subscription') && !isLegalPage) {
                    navigate('/subscription', { replace: true });
                }
            }
        };
        const timer = setTimeout(checkSubscriptionAndRedirect, 100);
        
        return () => clearTimeout(timer);
    }, [location.pathname, navigate, isLegalPage, isLogin]);

    console.log(isLogin);
    
    return (
        <div className="main-wrapper">
            { (isLogin || isLegalPage) && <Header /> }
            { (isLogin || isLegalPage) && <Sidebar /> }
            { (isLogin || isLegalPage) && <div className="page-wrapper">
                <div className="content container-fluid">
                    {Component}
                </div>
            </div> }
            <ToastContainer />
        </div>
    )
};

export default AdminLayout;  